<template>
    <div class="container-fluid" style="background-color: white;">
        <!--submit-->
        <div class="row">
            <div class="col text-right">
                <button class="btn btn-default margin next" @click="goToBackWord">
                    <icon name="backward"></icon>
                    ย้อนกลับ
                </button>
                <button class="btn btn-default margin next"
                        @click="goToEmployeeQuarantee">
                    <icon name="forward"></icon>
                    ถัดไป
                </button>
                <button class="btn btn-success margin"
                        @click="showConfirmModal">
                    <icon name="save"></icon>
                    บันทึกจบ
                </button>
                <button class="btn btn-danger margin" @click="goToEmployeeList">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
        </div>
        <!--data-->
        <div class="row">
            <div class="col-sm-6 border border-dark">
                <div style="padding: 10px">
                    <h5>แผนกที่สังกัด / ประเภทการจ้าง</h5>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>ตำแหน่ง</label> <span style="color: red ; font-weight: bold">*</span>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <b-form-select v-model="form.occupation.position_id"
                                           :options="optionPosition">
                            </b-form-select>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>แผนก</label> <span style="color: red ; font-weight: bold">*</span>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <b-form-select v-model="form.occupation.department_id"
                                           :options="optionDepartment">
                            </b-form-select>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>ประเภทการจ้าง</label> <span style="color: red ; font-weight: bold">*</span>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <div class="form-group">
                                <input type="radio" value="1" id="month"
                                       v-model="form.occupation.employee_type"/>
                                <label for="month">พนักงานประจำ</label><br/>
                                <input type="radio" value="2" id="days"
                                       v-model="form.occupation.employee_type"/>
                                <label for="days">พนักงานรายวัน</label>
                            </div>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>กะปัจจุบัน</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <multiselect
                                    :disabled="true"
                                    v-model="form.occupation.shift"
                                    :options="optionShiftEmployee"
                                    :show-labels="false"
                                    placeholder="เลือกกะการทำงาน"
                                    label="name"
                                    track-by="id">
                            </multiselect>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>เวลาเริ่มงาน</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <b-form-select v-model="form.occupation.start_work_time" :options="optionWorkTime"></b-form-select>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>เวลาเลิกงาน</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <b-form-select v-model="form.occupation.end_work_time" :options="optionWorkTime"></b-form-select>
                        </b-col>
                    </div>
                    <template v-if="form.occupation.department_id == 16">
                        <div class="row form-group" >
                            <b-col sm="6" class="col-sm-6 text-right">
                                <label>เลือกฐานมาคำนวนโบนัส</label>
                            </b-col>
                            <b-col sm="6" class="col-sm-6">
                                <div class="form-group">
                                    <input type="radio" value="1" id="11"
                                           v-model="form.occupation.rate"/>
                                    <label for="11">คอมมิชชันรวม (มีโฟม)</label><br/>
                                    <input type="radio" value="2" id="22"
                                           v-model="form.occupation.rate"/>
                                    <label for="22">คอมมิชชันเบ็ดเตล็ด (ไม่มีโฟม)</label><br/>
                                    <input type="radio" value="3" id="33"
                                           v-model="form.occupation.rate"/>
                                    <label for="33">คอมมิชชันประเภทสินค้า</label>
                                    <multiselect
                                        v-if="form.occupation.rate == 3"
                                        v-model="form.occupation.rate_sale_type"
                                        :options="optionProductType"
                                        track-by="id"
                                        multiple
                                        :show-labels="false"
                                        :custom-label="LabelName"
                                        placeholder="เลือกประเภทสินค้า">
                                    </multiselect>
                                </div>
                            </b-col>
                        </div>
                        <div class="row form-group" >
                            <b-col sm="6" class="col-sm-6 text-right">
                                <label>เลือก Rate การรับโบนัส(เฉพาะเซลล์)</label>
                            </b-col>
                            <b-col sm="6" class="col-sm-6">
                                <multiselect
                                    v-model="form.occupation.rate_bonus_group"
                                    :options="optionBonusSale"
                                    :custom-label="RateBonusSalelabel"
                                    :show-labels="false"
                                    placeholder="อัตราการรับโบนัส"
                                    track-by="id">
                                </multiselect>
                            </b-col>
                        </div>
                        <div class="row form-group" >
                            <b-col sm="6" class="col-sm-6 text-right">
                                <label>เลือก Rate การรับโบนัส(เฉพาะเซลล์)</label>
                            </b-col>
                            <b-col sm="6" class="col-sm-6">
                                <multiselect
                                    v-model="form.occupation.rate_bonus_group2"
                                    :options="optionBonusSale"
                                    :custom-label="RateBonusSalelabel"
                                    :show-labels="false"
                                    placeholder="อัตราการรับโบนัส"
                                    track-by="id">
                                </multiselect>
                            </b-col>
                        </div>
                        <div class="row form-group" >
                            <b-col sm="6" class="col-sm-6 text-right">
                                <label>เลือก Rate การรับโบนัส(เฉพาะเซลล์)</label>
                            </b-col>
                            <b-col sm="6" class="col-sm-6">
                                <multiselect
                                    v-model="form.occupation.rate_bonus_group3"
                                    :options="optionBonusSale"
                                    :custom-label="RateBonusSalelabel"
                                    :show-labels="false"
                                    placeholder="อัตราการรับโบนัส"
                                    track-by="id">
                                </multiselect>
                            </b-col>
                        </div>
                        <div class="row form-group" >
                            <b-col sm="6" class="col-sm-6 text-right">
                                <label>เลือก Rate การรับโบนัส(เฉพาะเซลล์)</label>
                            </b-col>
                            <b-col sm="6" class="col-sm-6">
                                <multiselect
                                    v-model="form.occupation.rate_bonus_group4"
                                    :options="optionBonusSale"
                                    :custom-label="RateBonusSalelabel"
                                    :show-labels="false"
                                    placeholder="อัตราการรับโบนัส"
                                    track-by="id">
                                </multiselect>
                            </b-col>
                        </div>
                        <div class="row form-group" >
                            <b-col sm="6" class="col-sm-6 text-right">
                                <label>เลือก Rate การรับโบนัส(เฉพาะเซลล์)</label>
                            </b-col>
                            <b-col sm="6" class="col-sm-6">
                                <multiselect
                                    v-model="form.occupation.rate_bonus_group5"
                                    :options="optionBonusSale"
                                    :custom-label="RateBonusSalelabel"
                                    :show-labels="false"
                                    placeholder="อัตราการรับโบนัส"
                                    track-by="id">
                                </multiselect>
                            </b-col>
                        </div>
                    </template>
                </div>
            </div>
            <div class="col-sm-6 border border-dark">
                <div style="padding: 10px">
                    <h5>การทำงาน</h5>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>วันที่เริ่มต้นทำงาน</label><span style="color: red ; font-weight: bold">*</span>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <date-picker
                                    v-model="form.work_benefit.work_start_date"
                                    :lang="lang"
                                    :format="changeFormat"
                                    class="w-100"
                                    placeholder="วันที่เริ่มต้นทำงาน">
                            </date-picker>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>วันที่บรรจุ</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <date-picker
                                    v-model="form.work_benefit.accept_offer_date"
                                    :lang="lang"
                                    :format="changeFormat"
                                    class="w-100"
                                    placeholder="วันที่บรรจุ">
                            </date-picker>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>วันที่เริ่มต้นคำนวณ</label><span style="color: red ; font-weight: bold">*</span>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <date-picker
                                    v-model="form.work_benefit.salary_pay_date"
                                    :lang="lang"
                                    :format="changeFormat"
                                    class="w-100"
                                    placeholder="วันที่เริ่มต้นคำนวณ">
                            </date-picker>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>เบี้ยขยัน</label><span style="color: red ; font-weight: bold">*</span>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <div class="form-group">
                                <input type="radio" value="1" id="1"
                                       v-model="form.work_benefit.benefit_type"/>
                                <label for="1">ได้เบี้ยขยัน</label><br/>
                                <input type="radio" value="2" id="2"
                                       v-model="form.work_benefit.benefit_type"/>
                                <label for="2">ไม่ได้เบี้ยขยัน</label><br/>
                                <input type="radio" value="3" id="3"
                                       v-model="form.work_benefit.benefit_type"/>
                                <label for="3">ได้เบี้ยขยันทุกครั้ง</label>
                            </div>
                        </b-col>
                    </div>
                    <div class="row form-group" v-if="form.work_benefit.benefit_type!=2">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>ยอดเงินเบี้ยขยัน (ครึ่งเดือน)</label><span style="color: red ; font-weight: bold">*</span>
                        </b-col>
                        <b-col sm="6" class="col-sm-6 form-inline">
                            <div class="form-group">
                                <input type="text" class="form-control col-sm-4"
                                       v-model="form.work_benefit.benefit_amount"/>
                                <label class="col-sm-2">บาท</label>
                            </div>
                        </b-col>
                    </div>
                    <div class="row form-group" v-if="form.work_benefit.benefit_type!=2">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>วันที่จ่ายเบี้ยขยัน</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6 form-inline">
                            <div class="form-group">
                                <date-picker
                                        v-model="form.work_benefit.benefit_date"
                                        :lang="lang"
                                        :format="changeFormat"
                                        class="w-100"
                                        placeholder="วันที่จ่ายเบี้ยขยัน">
                                </date-picker>
                            </div>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" style="margin-top: 10px; min-height: 480px">
            <div class="col-sm-4 border border-dark">
                <div style="padding: 10px">
                    <h5>เงินเดือนปัจจุบัน</h5>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>อัตรา</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <input type="number" placeholder="อัตราเงินเดือน"
                                   v-model="form.salary.salary"
                                   class="form-control"/>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>ต่อ</label> <span style="color: red ; font-weight: bold">*</span>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <div class="form-group">
                                <input type="radio" value="1" v-model="form.salary.salary_per_day" id="per_day"/>
                                <label for="per_day">ต่อวัน</label><br/>
                                <input type="radio" value="3" v-model="form.salary.salary_per_day" id="per_month"/>
                                <label for="per_month">ต่อเดือน</label>
                            </div>
                        </b-col>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>วันที่ปรับปรุง</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <date-picker
                                    v-model="form.salary.update_date"
                                    :lang="lang"
                                    :format="changeFormat"
                                    class="w-100"
                                    placeholder="วันที่ปรับปรุง">
                            </date-picker>
                        </b-col>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 border border-dark">
                <div style="padding: 10px">
                    <h5>งวดที่จ่าย</h5>
                    <b-col sm="6" class="col-sm-6">
                        งวดที่จ่าย<span style="color: red ; font-weight: bold">*</span>
                        <br/>
                        <div class="form-group float-right">
                            <input type="radio" value="1" v-model="form.salary.paid_period" id="paid_month"/>
                            <label for="paid_month">เดือน</label><br/>
                            <input type="radio" value="2" v-model="form.salary.paid_period" id="half_month"/>
                            <label for="half_month">ครึ่งเดือน</label><br/>
                        </div>
                    </b-col>
                </div>
            </div>
            <div class="col-sm-4 border border-dark">
                <div style="padding: 10px">
                    <h5>วิธีการจ่ายเงินเดือน</h5>
                    <div class="form-group">
                        <input type="radio" value="3" v-model="form.transaction.transaction_type_id" id="transaction_3" :disabled="!canViewSuperAdmin"/>
                        <label for="transaction_3">เงินสด</label><br/>
                        <input type="radio" value="2" v-model="form.transaction.transaction_type_id" id="transaction_2" :disabled="!canViewSuperAdmin"/>
                        <label for="transaction_2">โอนผ่านธนาคาร</label><br/>
                    </div>
                    <template v-if="form.transaction.transaction_type_id==2">
                        <div class="row form-group">
                            <b-col sm="6" class="col-sm-6 text-right">
                                <label>ชื่อธนาคาร</label> <span style="color: red ; font-weight: bold">*</span>
                            </b-col>
                            <b-col sm="6" class="col-sm-6">
                                <b-form-select :disabled="!canViewSuperAdmin" :options="bankAll" v-model="form.transaction.bank_name">
                                </b-form-select>
                            </b-col>
                        </div>
                        <div class="row form-group">
                            <b-col sm="6" class="col-sm-6 text-right">
                                <label>เลขบัญชี</label> <span style="color: red ; font-weight: bold">*</span>
                            </b-col>
                            <b-col sm="6" class="col-sm-6">
                                <input type="text" class="form-control"
                                       :disabled="!canViewSuperAdmin"
                                       v-model="form.transaction.account_name"
                                       placeholder="เลขบัญชี"/>
                            </b-col>
                        </div>
                        <div class="row form-group">
                            <b-col sm="6" class="col-sm-6 text-right">
                                <label>ชื่อบัญชี</label>
                            </b-col>
                            <b-col sm="6" class="col-sm-6">
                                <input type="text" class="form-control"
                                       :disabled="!canViewSuperAdmin"
                                       v-model="form.transaction.account_no"
                                       placeholder="ชื่อบัญชี"/>
                            </b-col>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <!--<pre class="alert alert-danger text-left">{{optionShiftEmployee}}</pre>-->
        <b-modal hide-header hide-footer ref="confirmEmp">
            <confirm-emp-modal @submit="saveEmployee">
            </confirm-emp-modal>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex"
import DatePicker from 'vue2-datepicker'
import Multiselect from "vue-multiselect";
import confirmEmpModal from "../../../Utility/ConfirmEmpModal";
import moment from "moment";
import {canViewSuperAdmin} from "../../../../util/Permissions";

export default {
        name: "employee-salary",
        components:{
            DatePicker,
            Multiselect,
            confirmEmpModal
        },

        props: {
            status_bar: { default: false },
        },
        created(){
            this.getDepartmentAll();
            this.$store.dispatch("Common/setPosition");
            this.$store.dispatch("Common/setShiftWorkEmployee");
            this.$store.dispatch("Common/setRateBonusSaleAll");
            this.$store.dispatch("Common/getBankType");
            this.$store.dispatch("Common/getWorkTime").then(res=>{
                this.optionWorkTime = [
                    {text : 'เลือก' , value : null},
                    ...res.map(time => ({
                        value: time.work_time,
                        text : time.work_time,
                    }))
                ]
            });
        },
        data(){
          return{
              optionWorkTime : [],
              optionDepartment:[],
              changeFormat: {
                  stringify: (date) => {
                      let date_moment = moment(date).format('YYYY');
                      const year = parseInt(date_moment) + 543;
                      return date ? moment(date).format('DD/MM/'+year) : null
                  },
                  parse: (value) => {
                      return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                  }
              },
              lang: {
                  days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                  months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                  pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                  placeholder: {
                      date: 'วว/ดด/ปปปป',
                  }
              },
          }
        },
        computed:{
            canViewSuperAdmin,
            ...mapState({
                form:state =>{
                    return state.Employee.employeeForm;
                },
                optionPosition:state=>{
                    return [
                        {
                            value: null,
                            text: "เลือก"
                        },
                        ...state.Common.position.map(position => ({
                            value: position.id,
                            text: position.name
                        }))
                    ];
                },
                optionShiftEmployee:state=>{
                    return state.Common.shift_work_employee;
                },
                optionBonusSale:state=>{
                    return state.Common.rate_bonus;
                },
                user:state=>{
                    return state.Auth.user;
                },
                bankAll:state=>{
                    return [
                        {
                            value: null,
                            text: "เลือก"
                        },
                        ...state.Common.bank_type.map(bank => ({
                            value: bank.name,
                            text: bank.name
                        }))
                    ];
                },
                optionProductType : state =>{
                    return state.ProductType.data;
                },
            })
        },
        methods:{
            LabelName (option) {
                return `${option.type_code} - ${option.name}`
            },
            showConfirmModal(){
                this.$refs.confirmEmp.show();
            },
            RateBonusSalelabel ({ name, start_price ,end_price }) {
                return `${name} - (${start_price} - ${end_price})`
            },
            RateSalelabel ({ name }) {
                return `${name}`
            },
            getDepartmentAll(){
                this.$store.dispatch("Department/getAllDepartment").then(res=>{
                    this.optionDepartment = [
                        {
                            value: null,
                            text: "เลือก"
                        },
                        ...res.map(data => ({
                            value: data.id,
                            text: data.department_name
                        }))
                    ]
                })
            },
            goToEmployeeList(){
                this.$router.push({
                    name : "employee"
                })
            },
            goToBackWord(){
                this.$router.push({
                    name : "employee-information-profile"
                })
            },
            saveEmployee(value){
                if(value) {
                    this.form.user_id = this.user.id;
                    this.form.occupation.rate_bonus_group_id = this.form.occupation.rate_bonus_group ? this.form.occupation.rate_bonus_group.id : '';
                    this.form.occupation.rate_bonus_group_id2 = this.form.occupation.rate_bonus_group2 ? this.form.occupation.rate_bonus_group2.id : '';
                    this.form.occupation.rate_bonus_group_id3 = this.form.occupation.rate_bonus_group3 ? this.form.occupation.rate_bonus_group3.id : '';
                    this.form.occupation.rate_bonus_group_id4 = this.form.occupation.rate_bonus_group4 ? this.form.occupation.rate_bonus_group4.id : '';
                    this.form.occupation.rate_bonus_group_id5 = this.form.occupation.rate_bonus_group5 ? this.form.occupation.rate_bonus_group5.id : '';
                    if (this.validateData()) {
                        this.$store.dispatch("Employee/saveEmployee", {
                            id: this.form.id,
                            data: this.form
                        });
                        this.goToEmployeeList();
                    }
                }else{
                    this.$refs.confirmEmp.hide();
                }
            },
            validateData(){
                if(!this.form.occupation.position_id){
                    alert("กรุณาเลือกแผนก");
                }
                else if(!this.form.occupation.employee_type){
                    alert("กรุณาเลือกประเภทการจ้าง");
                }
                else if(!this.form.salary.salary_per_day){
                    alert("กรุณาเลือกประเภทวันการจ่ายเงิน");
                }
                else if(!this.form.salary.paid_period){
                    alert("กรุณาเลือกงวดที่จ่าย");
                }
                else if(!this.form.work_benefit.work_start_date){
                    alert("กรุณาเลือกวันที่เริ่มต้นการทำงาน");
                }
                else if(!this.form.work_benefit.salary_pay_date){
                    alert("กรุณาเลือกวันที่เริ่มต้นคำนวณ");
                }
                else if(!this.form.work_benefit.benefit_type){
                    alert("กรุณาเลือกประเภทการรับเบี้ยขยัน");
                }
                else if(this.form.work_benefit.benefit_type != 2 && !this.form.work_benefit.benefit_amount){
                    alert("กรุณาใส่ยอดเงินเบี้ยขยัน")
                }
                else{
                    if(this.form.work_benefit.benefit_type==2){
                        this.form.work_benefit.benefit_amount = "";
                    }
                    else{
                        this.form.work_benefit.benefit_amount = parseFloat(this.form.work_benefit.benefit_amount);
                    }
                    if(this.form.salary.update_date){
                        this.form.salary.update_date = moment(this.form.salary.update_date).format("YYYY-MM-DD");
                    }
                    if(this.form.work_benefit.accept_offer_date){
                        this.form.work_benefit.accept_offer_date = moment(this.form.work_benefit.accept_offer_date).format("YYYY-MM-DD");
                    }
                    if(this.form.occupation.shift){
                        this.form.occupation.work_schedule_id = this.form.occupation.shift.id;
                    }
                    if(this.form.work_benefit.benefit_date){ //วันที่จ่ายเบี้ยขยัน
                        this.form.work_benefit.benefit_date = moment(this.form.work_benefit.benefit_date).format('YYYY-MM-DD');
                    }
                    if(this.form.occupation.rate_bonus_group){
                        this.form.occupation.rate_bonus_group_id = this.form.occupation.rate_bonus_group.id;
                    }
                    this.form.work_benefit.work_start_date = moment(this.form.work_benefit.work_start_date).format("YYYY-MM-DD");
                    this.form.work_benefit.salary_pay_date = moment(this.form.work_benefit.salary_pay_date).format("YYYY-MM-DD");

                    return true;
                }
            },
            goToEmployeeQuarantee(){
                if(this.validateData()){
                    this.$router.push({
                        name : "employee-information-quarantee"
                    })
                }
            },
        }
    }
</script>

<style scoped>
    body {font-family: Arial, Helvetica, sans-serif;}
    * {box-sizing: border-box;}

    .form-inline {
        display: flex;
        flex-flow: row wrap;
        /*align-items: left;*/
    }

    .form-inline label {
        margin: 5px 10px 5px 0;
    }

    .form-inline input {
        vertical-align: middle;
        margin: 5px 10px 5px 0;
        padding: 10px;
        background-color: #fff;
        border: 1px solid #ddd;
    }

    .form-inline button {
        padding: 10px 20px;
        border: 1px solid #ddd;
        color: white;
        cursor: pointer;
    }

    .form-inline button:hover {

    }

    @media (max-width: 800px) {
        .form-inline input {
            margin: 10px 0;
        }

        .form-inline {
            flex-direction: column;
            align-items: stretch;
        }
    }
    .padding{
        padding: 20px;
    }
    .margin{
        margin: 10px;
    }
</style>
